import React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { SOURCES } from 'client/utils/image-helpers';
import { Link } from 'site-modules/shared/components/link/link';
import { Image } from 'site-modules/shared/components/image/image';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

import './ratings.scss';

function RatingCard({ cardContent }) {
  const { 'media-image': image, title, 'link-url': link, 'promo-text': text } = cardContent.getAllMetadata();

  return (
    <Link to={link} className="rating-card-link-wrap d-block h-100">
      <div className="rating-card rounded h-100">
        <AspectRatioContainer aspectRatio="3:2">
          <Image imageId={image} source={SOURCES.MEDIA} alt={title} className="w-100 img-fluid" lazy />
        </AspectRatioContainer>
        <div className="py-1 px-0_5">
          <h3 className="heading-5">{title}</h3>
          <p className="size-14 text-gray-darker mb-0">{text}</p>
        </div>
      </div>
    </Link>
  );
}

RatingCard.propTypes = {
  cardContent: CmsEntities.Content,
};

RatingCard.defaultProps = {
  cardContent: DEFAULT_CONTENT,
};

export function Ratings({ ratingsContentEntry }) {
  const { title } = ratingsContentEntry;
  const anchorName = ratingsContentEntry.metadata('anchorName').value();
  const ratingsCards = ratingsContentEntry.children();

  return (
    <ScrollElement id={anchorName} tag="section" className="ratings pos-r">
      <h2 className="heading-3 mb-1_25">{title}</h2>
      <Row>
        {ratingsCards.map(cardContent => (
          <Col xs={12} md={4} key={cardContent.id} className="mb-1">
            <RatingCard cardContent={cardContent} />
          </Col>
        ))}
      </Row>
    </ScrollElement>
  );
}

Ratings.propTypes = {
  ratingsContentEntry: CmsEntities.Content,
};

Ratings.defaultProps = {
  ratingsContentEntry: DEFAULT_CONTENT,
};
